import ajax from '@/utils/request'

// 应用列表
export const applicationList = data => ajax('/api/application/get/list/', data, 'POST')
// 详情
export const applicationDetail = data => ajax('/api/application/get/', data, 'GET')
// 添加
export const applicationAdd = data => ajax('/api/application/add/', data, 'POST')
// 编辑
export const applicationUpdate = data => ajax('/api/application/update/', data, 'POST')
// 状态更新
export const applicationState = data => ajax('/api/application/update/state/', data, 'POST')
// 删除
export const applicationDel = data => ajax('/api/application/del/list/', data, 'POST')
// 发送验证码
export const applicationCode = data => ajax('/api/application/send/code/', data, 'POST')
// 更新秘钥
export const applicationSecretKey = data => ajax('/api/application/change/secretKey/', data, 'POST')
